module.exports = __webpack_public_path__ + "img/ps-26.7462d2ce.jpg";